/* eslint-disable import/prefer-default-export */
import { isObject } from 'formik'
import { isArray, keys, map } from 'lodash'

function parseItem<V extends {}, K = keyof V>(key: K, param: V[] | V) {
  if (isArray(param)) {
    const arrayParams = map(
      param,
      (item: string) => `${key}=${encodeURIComponent(item)}`
    )
    return arrayParams.join('&')
  }
  if (isObject(param)) {
    const arrayParams = map(
      param,
      (item, childKey) => `${key}.${parseItem(childKey, item)}`
    )
    return arrayParams.join('&')
  }
  return `${key}=${encodeURIComponent(param)}`
}

export function objectToQueryString<T extends {}>(
  params: T,
  transactionId?: string
) {
  const queryArray = map(keys(params), key => parseItem(key, params[key]))
  if (transactionId) {
    return `?req_hdr.tid=${transactionId}&${queryArray.join('&')}`
  }
  return queryArray.length > 0 ? `?${queryArray.join('&')}` : ``
}
